import React, { useContext } from 'react'
import AuthPage from '../../pages/AuthPage'
import ProfilePage from '../../pages/ProfilePage'
import StateContext from '../../StateContext'

function Home() {

    const appState = useContext(StateContext);

    if (!appState.loggedIn) return <AuthPage />

    return (
        <ProfilePage />
    )
}
export default Home